import NotificationTypeValidator from "Validators/Admin/NotificationType";
import { useState } from "react";

import { useFetch } from "Hooks/useFetch";
import { useFormSchema } from "Hooks/useFormSchema";

import Button from "Components/Admin/Buttons";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";
import IconSelect from "Components/Admin/IconSelect";
import Section from "Components/Admin/Section";

import * as S from "./styles";

const CreateNotificationType = () => {
  const { fetchData, loading } = useFetch();

  const [selectedIcon, setSelectedIcon] = useState("");

  const methods = useFormSchema(NotificationTypeValidator);

  const { register, reset } = methods;

  const submit = async (data) => {
    const successMessage = "Categoria de Notificação criada com sucesso!";
    const onSuccessCallback = () => {
      setSelectedIcon("");
      reset();
    };

    await fetchData({
      method: "post",
      path: "/notifications/create-notification-type",
      body: {
        ...data,
        icon: selectedIcon,
      },
      successMessage,
      onSuccessCallback,
      config: {
        show_success_message: true,
      },
    });
  };

  return (
    <Section>
      <S.Wrapper>
        <FormWrapper {...methods} submit={submit}>
          <Input
            {...register("display_name")}
            type="text"
            label="Nome"
            placeholder="Nome"
            required
          />

          <IconSelect
            icons={[
              "Envelope",
              "Heart",
              "Bell",
              "User",
              "Star",
              "Coins",
              "HelpCircle",
              "Magnifier",
              "Graph",
              "Hash",
              "Package",
              "Target",
              "Pointer",
              "Like",
              "News",
              "Calendar",
            ]}
            selectedIcon={selectedIcon}
            setSelectedIcon={setSelectedIcon}
          />

          <Button
            type="submit"
            text="Criar"
            disabled={loading || !selectedIcon}
          />
        </FormWrapper>
      </S.Wrapper>
    </Section>
  );
};

export default CreateNotificationType;
